import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QuizAnswerState {
  public valueList$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  public assignmentPoints$: BehaviorSubject<number> = new BehaviorSubject(0);
  public emitUnansweredBlockIds: EventEmitter<
    { id: number; hasAnswer: boolean }[]
  > = new EventEmitter();
  public emitSubmitAnswers: EventEmitter<boolean> = new EventEmitter(false);

  public addToAssignmentPoints() {
    const currentValue = this.assignmentPoints$.getValue();
    this.assignmentPoints$.next(currentValue + 1);
  }

  public storeAnswer(value: string, dayBlockId: number) {
    let currentValue = this.valueList$.getValue();
    currentValue = currentValue?.filter(
      (item) => item.dayBlockId !== dayBlockId,
    );
    this.valueList$.next(currentValue?.concat([{ value, dayBlockId }]));

    sessionStorage.setItem(
      'valueList',
      JSON.stringify(this.valueList$.getValue()),
    );
  }

  public getAnswer(dayBlockId: number): any[] {
    let answerList = [];
    const sessionData = sessionStorage.getItem('valueList');
    if (sessionData) {
      answerList = JSON.parse(sessionData);
      answerList = answerList?.filter((item) => item.dayBlockId === dayBlockId);
    }
    return answerList;
  }
}
